/**
 * This file should be overwritten by Traduki 2.0
 */
export default {
	'cross-flow-support.product-store': 'Product store',
	'cross-flow-support.back-to-all-products': 'Back to all products',
	'cross-flow-support.close': 'Close',
};
